import "./index.scss";

import { Box, Stack } from "@mui/material";
import { ReactComponent as IconDelete } from "assets/images/icons/delete.svg";
import SearchBar from "components/SearchBar";
import { FC, memo, useEffect, useState } from "react";

type selectedValueType = string | number;

export type TSearchablePileItem = {
  label: string;
  value?: selectedValueType;
};

interface SearchablePileProps {
  options: TSearchablePileItem[];
  callback: Function;
}

const SearchablePile: FC<SearchablePileProps> = (props) => {
  const { options = [], callback } = props;
  const [searchStr, setSearchStr] = useState("");
  const [filterOptions, setFilterOptions] = useState([]);

  useEffect(() => {
    let optionsWithValues = [];
    optionsWithValues = options.map((e) => {
      if (!e.value) {
        e.value = e.label;
      }
      return e;
    });
    setFilterOptions(optionsWithValues);
  }, [options]);

  //#region event handlers
  const handleSearch = (str: string) => {
    setFilterOptions([...options.filter((x) => x.label.toLowerCase().includes(str.toLowerCase()))]);
    setSearchStr(str);
  };

  const handleRemoveFromList = (item) => {
    if (callback) {
      callback(item);
    }
  };
  //#endregion event handlers

  return (
    <Box className={`searchable-list-container searchable-pile`}>
      <Box className="header">
        <SearchBar className="search-bar" value={searchStr} onSearch={handleSearch} />
      </Box>
      <Stack className="list tree-list" gap={"6px"}>
        {filterOptions.map((item, index) => (
          <Stack direction="row" className="item" key={`pileEntry_${index}`}>
            <Box flexGrow={1}>{item.label}</Box>
            <IconDelete onClick={() => handleRemoveFromList(item)} />
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default memo(SearchablePile);
